import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { SESv2ServiceException as __BaseException } from "./SESv2ServiceException";
export const ContactLanguage = {
    EN: "EN",
    JA: "JA",
};
export const MailType = {
    MARKETING: "MARKETING",
    TRANSACTIONAL: "TRANSACTIONAL",
};
export const ReviewStatus = {
    DENIED: "DENIED",
    FAILED: "FAILED",
    GRANTED: "GRANTED",
    PENDING: "PENDING",
};
export class AccountSuspendedException extends __BaseException {
    constructor(opts) {
        super({
            name: "AccountSuspendedException",
            $fault: "client",
            ...opts,
        });
        this.name = "AccountSuspendedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, AccountSuspendedException.prototype);
    }
}
export class AlreadyExistsException extends __BaseException {
    constructor(opts) {
        super({
            name: "AlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "AlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, AlreadyExistsException.prototype);
    }
}
export class BadRequestException extends __BaseException {
    constructor(opts) {
        super({
            name: "BadRequestException",
            $fault: "client",
            ...opts,
        });
        this.name = "BadRequestException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BadRequestException.prototype);
    }
}
export const MetricDimensionName = {
    CONFIGURATION_SET: "CONFIGURATION_SET",
    EMAIL_IDENTITY: "EMAIL_IDENTITY",
    ISP: "ISP",
};
export const Metric = {
    CLICK: "CLICK",
    COMPLAINT: "COMPLAINT",
    DELIVERY: "DELIVERY",
    DELIVERY_CLICK: "DELIVERY_CLICK",
    DELIVERY_COMPLAINT: "DELIVERY_COMPLAINT",
    DELIVERY_OPEN: "DELIVERY_OPEN",
    OPEN: "OPEN",
    PERMANENT_BOUNCE: "PERMANENT_BOUNCE",
    SEND: "SEND",
    TRANSIENT_BOUNCE: "TRANSIENT_BOUNCE",
};
export const MetricNamespace = {
    VDM: "VDM",
};
export const QueryErrorCode = {
    ACCESS_DENIED: "ACCESS_DENIED",
    INTERNAL_FAILURE: "INTERNAL_FAILURE",
};
export class InternalServiceErrorException extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServiceErrorException",
            $fault: "server",
            ...opts,
        });
        this.name = "InternalServiceErrorException";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServiceErrorException.prototype);
    }
}
export class NotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "NotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "NotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, NotFoundException.prototype);
    }
}
export class TooManyRequestsException extends __BaseException {
    constructor(opts) {
        super({
            name: "TooManyRequestsException",
            $fault: "client",
            ...opts,
        });
        this.name = "TooManyRequestsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TooManyRequestsException.prototype);
    }
}
export const BehaviorOnMxFailure = {
    REJECT_MESSAGE: "REJECT_MESSAGE",
    USE_DEFAULT_VALUE: "USE_DEFAULT_VALUE",
};
export const BulkEmailStatus = {
    ACCOUNT_DAILY_QUOTA_EXCEEDED: "ACCOUNT_DAILY_QUOTA_EXCEEDED",
    ACCOUNT_SENDING_PAUSED: "ACCOUNT_SENDING_PAUSED",
    ACCOUNT_SUSPENDED: "ACCOUNT_SUSPENDED",
    ACCOUNT_THROTTLED: "ACCOUNT_THROTTLED",
    CONFIGURATION_SET_NOT_FOUND: "CONFIGURATION_SET_NOT_FOUND",
    CONFIGURATION_SET_SENDING_PAUSED: "CONFIGURATION_SET_SENDING_PAUSED",
    FAILED: "FAILED",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_SENDING_POOL_NAME: "INVALID_SENDING_POOL_NAME",
    MAIL_FROM_DOMAIN_NOT_VERIFIED: "MAIL_FROM_DOMAIN_NOT_VERIFIED",
    MESSAGE_REJECTED: "MESSAGE_REJECTED",
    SUCCESS: "SUCCESS",
    TEMPLATE_NOT_FOUND: "TEMPLATE_NOT_FOUND",
    TRANSIENT_FAILURE: "TRANSIENT_FAILURE",
};
export const DimensionValueSource = {
    EMAIL_HEADER: "EMAIL_HEADER",
    LINK_TAG: "LINK_TAG",
    MESSAGE_TAG: "MESSAGE_TAG",
};
export class ConcurrentModificationException extends __BaseException {
    constructor(opts) {
        super({
            name: "ConcurrentModificationException",
            $fault: "server",
            ...opts,
        });
        this.name = "ConcurrentModificationException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ConcurrentModificationException.prototype);
    }
}
export class ConflictException extends __BaseException {
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        this.name = "ConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ConflictException.prototype);
    }
}
export const SubscriptionStatus = {
    OPT_IN: "OPT_IN",
    OPT_OUT: "OPT_OUT",
};
export const ContactListImportAction = {
    DELETE: "DELETE",
    PUT: "PUT",
};
export const TlsPolicy = {
    OPTIONAL: "OPTIONAL",
    REQUIRE: "REQUIRE",
};
export const SuppressionListReason = {
    BOUNCE: "BOUNCE",
    COMPLAINT: "COMPLAINT",
};
export const FeatureStatus = {
    DISABLED: "DISABLED",
    ENABLED: "ENABLED",
};
export class LimitExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "LimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LimitExceededException.prototype);
    }
}
export const EventType = {
    BOUNCE: "BOUNCE",
    CLICK: "CLICK",
    COMPLAINT: "COMPLAINT",
    DELIVERY: "DELIVERY",
    DELIVERY_DELAY: "DELIVERY_DELAY",
    OPEN: "OPEN",
    REJECT: "REJECT",
    RENDERING_FAILURE: "RENDERING_FAILURE",
    SEND: "SEND",
    SUBSCRIPTION: "SUBSCRIPTION",
};
export const ScalingMode = {
    MANAGED: "MANAGED",
    STANDARD: "STANDARD",
};
export const DeliverabilityTestStatus = {
    COMPLETED: "COMPLETED",
    IN_PROGRESS: "IN_PROGRESS",
};
export class MailFromDomainNotVerifiedException extends __BaseException {
    constructor(opts) {
        super({
            name: "MailFromDomainNotVerifiedException",
            $fault: "client",
            ...opts,
        });
        this.name = "MailFromDomainNotVerifiedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, MailFromDomainNotVerifiedException.prototype);
    }
}
export class MessageRejected extends __BaseException {
    constructor(opts) {
        super({
            name: "MessageRejected",
            $fault: "client",
            ...opts,
        });
        this.name = "MessageRejected";
        this.$fault = "client";
        Object.setPrototypeOf(this, MessageRejected.prototype);
    }
}
export class SendingPausedException extends __BaseException {
    constructor(opts) {
        super({
            name: "SendingPausedException",
            $fault: "client",
            ...opts,
        });
        this.name = "SendingPausedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, SendingPausedException.prototype);
    }
}
export const DkimSigningKeyLength = {
    RSA_1024_BIT: "RSA_1024_BIT",
    RSA_2048_BIT: "RSA_2048_BIT",
};
export const DkimSigningAttributesOrigin = {
    AWS_SES: "AWS_SES",
    EXTERNAL: "EXTERNAL",
};
export const DkimStatus = {
    FAILED: "FAILED",
    NOT_STARTED: "NOT_STARTED",
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    TEMPORARY_FAILURE: "TEMPORARY_FAILURE",
};
export const IdentityType = {
    DOMAIN: "DOMAIN",
    EMAIL_ADDRESS: "EMAIL_ADDRESS",
    MANAGED_DOMAIN: "MANAGED_DOMAIN",
};
export const DataFormat = {
    CSV: "CSV",
    JSON: "JSON",
};
export const SuppressionListImportAction = {
    DELETE: "DELETE",
    PUT: "PUT",
};
export const WarmupStatus = {
    DONE: "DONE",
    IN_PROGRESS: "IN_PROGRESS",
};
export const DeliverabilityDashboardAccountStatus = {
    ACTIVE: "ACTIVE",
    DISABLED: "DISABLED",
    PENDING_EXPIRATION: "PENDING_EXPIRATION",
};
export const MailFromDomainStatus = {
    FAILED: "FAILED",
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    TEMPORARY_FAILURE: "TEMPORARY_FAILURE",
};
export const VerificationStatus = {
    FAILED: "FAILED",
    NOT_STARTED: "NOT_STARTED",
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    TEMPORARY_FAILURE: "TEMPORARY_FAILURE",
};
export const JobStatus = {
    COMPLETED: "COMPLETED",
    CREATED: "CREATED",
    FAILED: "FAILED",
    PROCESSING: "PROCESSING",
};
export const ImportDestinationType = {
    CONTACT_LIST: "CONTACT_LIST",
    SUPPRESSION_LIST: "SUPPRESSION_LIST",
};
export class InvalidNextTokenException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidNextTokenException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidNextTokenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidNextTokenException.prototype);
    }
}
export const ListRecommendationsFilterKey = {
    IMPACT: "IMPACT",
    RESOURCE_ARN: "RESOURCE_ARN",
    STATUS: "STATUS",
    TYPE: "TYPE",
};
export const RecommendationImpact = {
    HIGH: "HIGH",
    LOW: "LOW",
};
export const RecommendationStatus = {
    FIXED: "FIXED",
    OPEN: "OPEN",
};
export const RecommendationType = {
    BIMI: "BIMI",
    DKIM: "DKIM",
    DMARC: "DMARC",
    SPF: "SPF",
};
export const AccountDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.WebsiteURL && { WebsiteURL: SENSITIVE_STRING }),
    ...(obj.UseCaseDescription && { UseCaseDescription: SENSITIVE_STRING }),
    ...(obj.AdditionalContactEmailAddresses && { AdditionalContactEmailAddresses: SENSITIVE_STRING }),
});
export const DkimSigningAttributesFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DomainSigningPrivateKey && { DomainSigningPrivateKey: SENSITIVE_STRING }),
});
export const CreateEmailIdentityRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DkimSigningAttributes && {
        DkimSigningAttributes: DkimSigningAttributesFilterSensitiveLog(obj.DkimSigningAttributes),
    }),
});
export const GetAccountResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Details && { Details: AccountDetailsFilterSensitiveLog(obj.Details) }),
});
export const PutAccountDetailsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.WebsiteURL && { WebsiteURL: SENSITIVE_STRING }),
    ...(obj.UseCaseDescription && { UseCaseDescription: SENSITIVE_STRING }),
    ...(obj.AdditionalContactEmailAddresses && { AdditionalContactEmailAddresses: SENSITIVE_STRING }),
});
export const PutEmailIdentityDkimSigningAttributesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SigningAttributes && { SigningAttributes: DkimSigningAttributesFilterSensitiveLog(obj.SigningAttributes) }),
});
